import { FC, useEffect, useState } from "react";

import styles from "./components/Button/Button.module.css";
import {
  sendLinkToEmail,
  signinAppleWithPopup,
  signinGoogleWithPopup,
} from "./services/firebase";
import { QRCodeSVG } from "qrcode.react";
import { UserDb } from "./models/user.db";
import { User } from "firebase/auth";
import { isDefined } from "./utils/objects";
import { AppPlatform, detectPlatform } from "./utils/platform";

type ElementProps = {
  children: string | JSX.Element | JSX.Element[] | undefined;
};

const ModalContainer: FC<ElementProps> = ({ children }) => {
  return (
    <div
      style={{
        boxSizing: "border-box",
        width: "306px",
        minHeight: "400px",
        //width: "100vw",
        //height: "100vh",
        paddingBottom: 43,
        paddingTop: 43,
        paddingRight: 27,
        paddingLeft: 27,
        borderRadius: "50px 0px",
        border: "0.5px solid #000",
        background: "#F5F1E5",
      }}
    >
      {children}
    </div>
  );
};

const ContainerColumn: FC<ElementProps> = ({ children }) => {
  return (
    <div
      style={{
        color: "#000",
        textAlign: "left",
        fontFamily: "Spezia",
        fontSize: "12px",
        fontStyle: "normal",
        fontWeight: "500",
        lineHeight: "normal",
        display: "flex",
        flexDirection: "column",
        alignItems: "start",
        gap: "20px",
      }}
    >
      {children}
    </div>
  );
};

function checkEmail(email: string) {
  const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return regex.test(email);
}

interface PropTypes {
  closeModal: () => void;
  ocUser: UserDb | null;
  indyxUser: UserDb | null;
  fbUser: User | null | undefined;
  updateUser: (upd: Partial<UserDb>) => Promise<void>;
  logOut: () => Promise<void>;
}

export const OcModat: FC<PropTypes> = ({
  ocUser,
  indyxUser,
  fbUser,
  closeModal,
  logOut,
  updateUser,
}) => {
  const [isOptions, setOptions] = useState(false);
  const [askEmail, setAskEmail] = useState(false);
  const [emailSent, setEmailSent] = useState(false);

  const [email, setEmail] = useState("");
  const [firstName, setFirstname] = useState("");
  const [lastName, setLastName] = useState("");

  const isValidEmail = checkEmail(email);

  const [isLogin, setIsLogin] = useState(false);

  const [showWelcome, setShowWelcome] = useState(false);

  const platform = detectPlatform();

  const isMobile =
    platform === AppPlatform.android || platform === AppPlatform.ios;

  useEffect(() => {
    const fullRegName = localStorage.getItem("fullRegName") || "";
    const splittedFullRegName = fullRegName.split(" ");
    const regFirstName = splittedFullRegName[0] ?? "";
    const regLastName = splittedFullRegName[1] ?? "";
    setFirstname((indyxUser?.firstName ?? "") || regFirstName);
    setLastName((indyxUser?.lastName ?? "") || regLastName);
    setEmail(indyxUser?.email ?? "");
  }, [indyxUser?.firstName, indyxUser?.lastName, indyxUser?.email]);

  const okIndyxUser = fbUser && indyxUser;
  const okIndyxData =
    isDefined(indyxUser?.firstName) &&
    isDefined(indyxUser?.lastName) &&
    isDefined(indyxUser?.socialMediaSource) &&
    isDefined(indyxUser?.goals) &&
    isDefined(indyxUser?.sourceAttributionText);

  if (!fbUser) {
    if (isLogin) {
      return (
        <ModalContainer>
          <div onClick={closeModal}></div>
          <div style={{ display: "flex", flexDirection: "column" }}>
            <div
              style={{
                fontSize: 17,
                fontWeight: 700,
                display: "flex",
              }}
            >
              <img
                src="/icons/material-symbols-light_keyboard-arrow-left.svg"
                alt=""
                onClick={() => {
                  setIsLogin(false);
                }}
                style={{ cursor: "pointer" }}
              />
              Scan the QR code
            </div>
            <div style={{ paddingTop: 20, paddingBottom: 20 }}>
              Go to {ocUser?.firstName ?? ""}’s closet in-app to style them!
            </div>
            <div
              style={{
                display: "flex",
                alignSelf: "center",
                padding: 20,
              }}
            >
              <QRCodeSVG
                size={128}
                bgColor="#F5F1E5"
                value={window.location.href}
              />
              ,
            </div>
          </div>
        </ModalContainer>
      );
    }
    if (emailSent) {
      return (
        <ModalContainer>
          <ContainerColumn>
            <div
              style={{
                fontSize: 17,
                fontWeight: 700,
              }}
            >
              Please verify your email
            </div>
            <div>
              An email verification was sent to your email. Please click on the
              link within the email to complete account creation.
            </div>
          </ContainerColumn>
        </ModalContainer>
      );
    }
    if (askEmail) {
      return (
        <ModalContainer>
          <ContainerColumn>
            <div
              style={{
                fontSize: 17,
                fontWeight: 700,
              }}
            >
              Continue with email
            </div>
            <div>What is your email?</div>
            <input
              type="text"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              onKeyDown={async (e) => {
                if (e.keyCode === 13 && isValidEmail) {
                  await sendLinkToEmail(email);
                  setAskEmail(false);
                  setEmailSent(true);
                  // put the login here
                }
              }}
              placeholder={"Enter email"}
              style={{
                alignSelf: "stretch",
                height: 28,
                borderRadius: 5,
                border: "0.5px solid #000",
                background: "#FFF",
                //
                fontFamily: "Spezia",
                fontSize: 12,
                fontStyle: "normal",
                fontWeight: 500,
                lineHeight: "normal",
                paddingLeft: 7,
                paddingRight: 7,
              }}
            />
            <div
              className={styles.btn}
              style={{
                background: "#113431",
                marginBottom: 15,
                alignSelf: "stretch",
                opacity: isValidEmail ? 1 : 0.5,
              }}
              onClick={
                isValidEmail
                  ? async () => {
                      await sendLinkToEmail(email);
                      setAskEmail(false);
                      setEmailSent(true);
                    }
                  : undefined
              }
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <div
                  style={{
                    color: "#FFF",
                  }}
                  className={styles.textBtn}
                >
                  Continue
                </div>
              </div>

              <div className={styles.nextBtn}>
                <img
                  src="/icons/white_arrow@3x.png"
                  width={20}
                  height={10}
                  alt="next"
                />
              </div>
            </div>
          </ContainerColumn>
        </ModalContainer>
      );
    }
    return (
      <ModalContainer>
        <div onClick={closeModal}></div>
        <ContainerColumn>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "start",
            }}
          >
            <div
              style={{
                fontSize: 17,
                fontWeight: 700,
              }}
            >
              Sign Up in Seconds
            </div>
            <div>Create an account to style {ocUser?.firstName ?? ""}</div>
          </div>

          <div style={{ width: "100%" }}>
            <div
              className={styles.btn}
              style={{ background: "#113431", marginBottom: 15 }}
              onClick={() => {
                signinGoogleWithPopup();
              }}
            >
              <div style={{ display: "flex", alignItems: "center" }}>
                <img
                  style={{ paddingRight: 17 }}
                  src="/icons/arcticons_google-alt.svg"
                  width={20}
                  height={20}
                  alt="google"
                />
                <div
                  style={{
                    color: "#FFF",
                  }}
                  className={styles.textBtn}
                >
                  Sign Up with Google
                </div>
              </div>

              <div className={styles.nextBtn}>
                <img
                  src="/icons/white_arrow@3x.png"
                  width={20}
                  height={10}
                  alt="next"
                />
              </div>
            </div>

            {!isOptions ? (
              <div
                className={styles.btn}
                style={{ marginBottom: 15 }}
                onClick={() => {
                  setOptions(true);
                }}
              >
                <div style={{ display: "flex", alignItems: "center" }}>
                  <img
                    style={{ paddingRight: 17 }}
                    src="/icons/material-symbols-light_more-vert.svg"
                    width={20}
                    height={20}
                    alt="google"
                  />
                  <div className={styles.textBtn}>Other Sign Up Options</div>
                </div>

                <div className={styles.nextBtn}>
                  <img
                    src="/icons/black_arrow@3x.png"
                    width={20}
                    height={10}
                    alt="next"
                  />
                </div>
              </div>
            ) : (
              <>
                <div
                  className={styles.btn}
                  style={{ marginBottom: 15 }}
                  onClick={() => {
                    signinAppleWithPopup();
                  }}
                >
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <img
                      style={{ paddingRight: 17 }}
                      src="/icons/ion_logo-apple.svg"
                      width={20}
                      height={20}
                      alt="google"
                    />
                    <div className={styles.textBtn}>Sign Up with Apple</div>
                  </div>

                  <div className={styles.nextBtn}>
                    <img
                      src="/icons/black_arrow@3x.png"
                      width={20}
                      height={10}
                      alt="next"
                    />
                  </div>
                </div>
                <div
                  className={styles.btn}
                  style={{ marginBottom: 15 }}
                  onClick={() => {
                    setAskEmail(true);
                  }}
                >
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <img
                      style={{ paddingRight: 17 }}
                      src="/icons/arcticons_mail.svg"
                      width={20}
                      height={20}
                      alt="google"
                    />
                    <div className={styles.textBtn}>Continue with Email</div>
                  </div>

                  <div className={styles.nextBtn}>
                    <img
                      src="/icons/black_arrow@3x.png"
                      width={20}
                      height={10}
                      alt="next"
                    />
                  </div>
                </div>
              </>
            )}
            <div
              style={{
                paddingBottom: 20,
                textDecoration: "underline",
                cursor: "pointer",
              }}
              onClick={() => {
                setIsLogin(true);
              }}
            >
              Already have an Indyx account? Click here.
            </div>
            <div
              style={{
                marginTop: 50,
                textAlign: "left",
                bottom: "50px",
                fontSize: 10,
                fontFamily: "Spezia",
              }}
            >
              By continuing, you agree to Indyx’s{" "}
              <a href="https://www.myindyx.com/terms-and-conditions">
                Terms of Use
              </a>
              . Read our{" "}
              <a href="https://www.myindyx.com/privacy-policy">
                Privacy Policy
              </a>
              .
            </div>
          </div>
        </ContainerColumn>
      </ModalContainer>
    );
  } else {
    if (showWelcome) {
      return (
        <ModalContainer>
          <ContainerColumn>
            <div
              style={{
                fontSize: 17,
                fontWeight: 700,
              }}
            >
              Welcome to Indyx
            </div>
            <div>
              You can now download the Indyx app and pop straight to{" "}
              {ocUser?.firstName}’s wardrobe to style her.
            </div>

            <div
              style={{
                display: "flex",
                alignSelf: "center",
              }}
            >
              {!isMobile ? (
                <QRCodeSVG
                  size={128}
                  bgColor="#F5F1E5"
                  value={"https://" + window.location.hostname + "/link.html"}
                />
              ) : (
                <div>
                  <div
                    style={{
                      display: "flex",
                      flex: 1,
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    {platform === AppPlatform.ios ? (
                      <a
                        href="https://apps.apple.com/us/app/indyx-wardrobe-outfit-app/id1599179405"
                        style={{ textDecoration: "none" }}
                      >
                        <img
                          width={159}
                          src="https://images.squarespace-cdn.com/content/v1/6321094c82fde37e691eb3f2/520f1895-8890-48ad-a27d-f53eb21b8376/App%2BStore%2BBadge.png?format=750w"
                          alt="ios"
                        />
                      </a>
                    ) : null}
                    {platform === AppPlatform.android ? (
                      <a
                        href="https://play.google.com/store/apps/details?gl=US&hl=en_US&id=com.indyx.android"
                        style={{ textDecoration: "none" }}
                      >
                        <img
                          width={159}
                          src="https://images.squarespace-cdn.com/content/v1/6321094c82fde37e691eb3f2/a5ca2abb-b29c-4f8f-a453-4910d057062a/Google%2BPlay%2BBadge.png?format=750w"
                          alt="android"
                        />
                      </a>
                    ) : null}
                  </div>
                </div>
              )}
            </div>

            <div>Choose “Already have an account?” to log in.</div>
            <img
              src="/images/WelcomePage.png"
              width={254}
              height={150}
              alt="welcomeimage"
            />
          </ContainerColumn>
        </ModalContainer>
      );
    }
    if (okIndyxUser && !okIndyxData) {
      return (
        <ModalContainer>
          <ContainerColumn>
            <div
              style={{
                fontSize: 17,
                fontWeight: 700,
              }}
            >
              Continue with email
            </div>
            <div>You’re creating an Indyx account with {email}</div>
            <input
              type="text"
              value={firstName}
              onChange={(e) => setFirstname(e.target.value)}
              onKeyDown={async (e) => {}}
              placeholder={"Enter first name"}
              style={{
                alignSelf: "stretch",
                height: 28,
                borderRadius: 5,
                border: "0.5px solid #000",
                background: "#FFF",
                //
                fontFamily: "Spezia",
                fontSize: 12,
                fontStyle: "normal",
                fontWeight: 500,
                lineHeight: "normal",
                paddingLeft: 7,
                paddingRight: 7,
              }}
            />
            <input
              type="text"
              value={lastName}
              onChange={(e) => setLastName(e.target.value)}
              onKeyDown={async (e) => {}}
              placeholder={"Enter last name"}
              style={{
                alignSelf: "stretch",
                height: 28,
                borderRadius: 5,
                border: "0.5px solid #000",
                background: "#FFF",
                //
                fontFamily: "Spezia",
                fontSize: 12,
                fontStyle: "normal",
                fontWeight: 500,
                lineHeight: "normal",
                paddingLeft: 7,
                paddingRight: 7,
              }}
            />
            <div
              className={styles.btn}
              style={{
                background: "#113431",
                marginBottom: 15,
                alignSelf: "stretch",
                opacity: firstName && lastName ? 1 : 0.5,
              }}
              onClick={
                firstName && lastName
                  ? async () => {
                      const upd: Partial<UserDb> = {
                        firstName: firstName,
                        lastName: lastName,
                      };

                      if (!isDefined(indyxUser?.sourceAttributionText)) {
                        upd.sourceAttributionText = "Friend or Family";
                      }
                      if (!isDefined(indyxUser?.socialMediaSource)) {
                        upd.socialMediaSource = ocUser?.username ?? null;
                      }
                      if (!isDefined(indyxUser?.goals)) {
                        upd.goals = ["I want to style my friends."];
                      }
                      if (!isDefined(indyxUser?.otherSourceText)) {
                        upd.otherSourceText = ocUser?.username ?? null;
                      }
                      upd.isWeb = true;
                      upd.openOc = true;
                      setShowWelcome(true);
                      await updateUser(upd);
                    }
                  : undefined
              }
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <div
                  style={{
                    color: "#FFF",
                  }}
                  className={styles.textBtn}
                >
                  Continue
                </div>
              </div>

              <div className={styles.nextBtn}>
                <img
                  src="/icons/white_arrow@3x.png"
                  width={20}
                  height={10}
                  alt="next"
                />
              </div>
            </div>
          </ContainerColumn>
        </ModalContainer>
      );
    }

    return (
      <ModalContainer>
        <div onClick={closeModal}></div>
        <div style={{ display: "flex", flexDirection: "column" }}>
          <div
            style={{
              fontSize: 17,
              fontWeight: 700,
              display: "flex",
            }}
          >
            <img
              src="/icons/material-symbols-light_keyboard-arrow-left.svg"
              alt=""
              onClick={() => {
                logOut();
              }}
              style={{ cursor: "pointer" }}
            />
            Scan the QR code
          </div>
          <div style={{ paddingTop: 20, paddingBottom: 20 }}>
            Go to {ocUser?.firstName ?? ""}’s closet in-app to style them!
          </div>
          <div
            style={{
              display: "flex",
              alignSelf: "center",
              padding: 20,
            }}
          >
            <QRCodeSVG
              size={128}
              bgColor="#F5F1E5"
              value={window.location.href}
            />
            ,
          </div>
        </div>
      </ModalContainer>
    );
  }
};
